export default __webpack_public_path__ + "static/media/NewCollaboration.68b83fdc.png";